import { isRecord } from 'lib/object/objectUtils'

export function readCurrencyCode(value: unknown): string | undefined {
  if (!isRecord(value)) return undefined
  const code = value.currencyCode
  return typeof code === 'string' && code.length > 0 ? code : undefined
}

/**
 * Helper function to build context string for offers to send with chat messages
 */
export function buildOfferContext(
  offer: App.AnyOffer,
  propertyName: string,
  description: string | undefined,
  roomPackages: Array<{
    name: string
    price?: number
    currencyCode?: string
  }>,
  finePrint: string | undefined,
  offerUrl: string | undefined,
  currentCurrency: string,
): string {
  const roomsInfo = roomPackages.map(pkg => {
    const priceStr = typeof pkg.price === 'number'
      ? `${pkg.currencyCode || currentCurrency} ${pkg.price}`
      : 'Price not available'
    return `- ${pkg.name}: ${priceStr}`
  }).join('\n')

  const lowestPackage = 'lowestPricePackage' in offer ? offer.lowestPricePackage : undefined
  const lowestPackageCurrency = readCurrencyCode(lowestPackage) ?? currentCurrency
  const priceInfo = lowestPackage
    ? `Starting from: ${lowestPackageCurrency} ${lowestPackage.price}`
    : ''

  const offerContext = [
    'The user asked a question with this offer visible on their screen:',
    `${propertyName}`,
    `Offer Type: ${offer.type}`,
    description ? `Description: ${description}` : '',
    priceInfo,
    roomPackages.length > 0 ? `\nRooms:\n${roomsInfo}` : '',
    finePrint ? `\nFine print: ${finePrint.substring(0, 500)}${finePrint.length > 500 ? '...' : ''}` : '',
    offerUrl ? `\nOffer URL: ${window.location.origin}${offerUrl}` : '',
  ].filter(Boolean).join('\n')

  return offerContext
}
